const about = {
  brand: {
    title: "品牌介绍",
    subtitle: "关于开云平台",
    description1: "开云平台成立于2018年，是一家专注于提供安全、稳定、便捷的平台服务的创新型科技企业。经过多年的发展，开云平台已累计服务超过百万用户，赢得了广泛的市场认可和用户信赖。",
    description2: "我们始终坚持以用户为中心，不断优化产品功能和服务体验。从最初的单一服务模块，发展到如今涵盖多个领域的综合服务平台，开云平台始终保持着对品质的执着追求。",
    description3: "开云平台拥有一支由资深技术专家和优秀产品经理组成的核心团队，致力于为用户打造安全可靠、体验卓越的平台服务。",
  },
  reputation: {
    title: "平台口碑",
    subtitle: "用户对我们的评价",
    items: [
      {
        name: "张先生",
        role: "资深用户",
        content: "使用开云平台三年了，一直很稳定安全。客服响应速度很快，遇到问题都能及时解决，非常值得信赖。",
        rating: 5,
      },
      {
        name: "李女士",
        role: "活跃用户",
        content: "平台的界面设计简洁大方，操作流程也很清晰。作为新用户也能快速上手，体验非常好。",
        rating: 5,
      },
      {
        name: "王先生",
        role: "长期用户",
        content: "开云平台的安全措施让我很放心，每次异地登录都会有提醒。客服也是7×24小时在线，很专业。",
        rating: 5,
      },
      {
        name: "赵女士",
        role: "忠实用户",
        content: "用了很多平台，开云是让我最安心的一个。功能更新及时，一直在进步，推荐给身边很多朋友了。",
        rating: 5,
      },
    ],
  },
  contact: {
    title: "联系我们",
    subtitle: "我们随时为您服务",
    form: {
      name: "姓名",
      namePlaceholder: "请输入您的姓名",
      email: "邮箱",
      emailPlaceholder: "请输入您的邮箱地址",
      phone: "电话",
      phonePlaceholder: "请输入您的联系电话",
      subject: "主题",
      subjectPlaceholder: "请选择咨询主题",
      subjectOptions: ["账户问题", "安全咨询", "功能建议", "投诉建议", "商务合作", "其他"],
      message: "留言内容",
      messagePlaceholder: "请输入您想咨询的内容（500字以内）",
      submit: "提交留言",
      success: "提交成功！我们会尽快与您联系。",
      error: "提交失败，请稍后重试。",
    },
    info: {
      title: "联系方式",
      hotline: "客服热线",
      hotlineValue: "400-XXX-XXXX",
      email: "客服邮箱",
      emailValue: "support@kaiyun.com",
      address: "公司地址",
      addressValue: "北京市朝阳区建国路88号",
      hours: "服务时间",
      hoursValue: "7×24小时全天候服务",
    },
  },
  milestones: {
    title: "发展历程",
    subtitle: "一路走来的重要时刻",
    items: [
      { year: "2018", event: "开云平台正式成立，推出首版平台服务" },
      { year: "2019", event: "用户数量突破10万，完成首轮产品升级" },
      { year: "2020", event: "上线安全中心模块，全面升级账户保护体系" },
      { year: "2021", event: "推出移动客户端，支持多端同步使用" },
      { year: "2022", event: "累计服务用户突破50万，获行业多项认可" },
      { year: "2023", event: "平台全面改版升级，用户体验大幅提升" },
      { year: "2024", event: "上线智能推荐系统，服务能力再上新台阶" },
      { year: "2025", event: "用户规模突破百万，持续引领行业发展" },
      { year: "2026", event: "推出全新品牌形象，开启全球化发展新征程" },
    ],
  },
};

export default about;